import { Injectable, Optional, SkipSelf } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';


export interface State {
  userName: string;
}

@Injectable({ providedIn: 'root' })
export class StateService {
  constructor(@Optional() @SkipSelf() parentModule: StateService) {
    if (parentModule) {
      throw new Error(
        'State Service is already loaded. Do not include in local provider array, it is already available through root.'
      );
    }
  }
  private initialState: State = {
    userName: '',
  };
  public currentState: State = this.initialState;

  private stateSubject = new BehaviorSubject<State>(this.initialState);
  public state$: Observable<State> = this.stateSubject.asObservable();

  public setState(propName: keyof State, newValue: any) {
		this.currentState[propName] = newValue;
		this.stateSubject.next(this.currentState);
	}

  public updateState(partialState: Partial<State>): void {
    const currentState = this.stateSubject.getValue();
    const updatedState = { ...currentState, ...partialState };
    this.stateSubject.next(updatedState);
  }

  getState(key : keyof State): any {
		return this.currentState[key];
	  }
}